export default __webpack_public_path__ + "static/media/Raghunandan_G.aea645ba.png";